<template>
  <div>
    <ListDetail />
  </div>
</template>

<script>

import ListDetail from '@/febos/global/emails/components/suppressed/ListDetail';

export default {
  name: 'SuppressedList',
  components: {
    ListDetail
  },
  data() {
    return {
      filter: null
    };
  }
};
</script>

<style>

</style>
